import React from 'react';

export function TextInput({ name, placeHolder, disable, label, requiredField, charCount, maxCount, value, onlyRead, onChange, path, error }) {
  return (
    <>
      <div className="input-group form-floating-label-po fixed-label ">
        <label className="asterisk-req">
          {label}
          {requiredField && <span>*</span>}
        </label>
        <input
          type="text"
          name={name}
          placeholder={placeHolder}
          className="form-control"
          disabled={disable}
          value={value}
          autoComplete="off"
          readOnly={onlyRead}
          onChange={(e) => onChange(e.target.value, path)}
        />
        {charCount && <div className="text-count">0/{maxCount}</div>}
      </div>
      {error?.status && <span className="error-message">{error?.errorMsg}</span>}
    </>
  );
}
export default TextInput;
